module.exports = __webpack_public_path__ + "media/src/img/cloud-bg-115ffb006fb6fc08bda2f5a336708fb3afe92da0c19ac353f225f9a5f901c80f.svg";